module.exports = __webpack_public_path__ + "assets/4b6a06b1331f165d023a0cbda97281ae.json";